export interface FollowLink {
  title: string;
  href: string;
  icon: string;
}

export const followLinks: Array<FollowLink> = [
  {
    title: "GitHub",
    href: "https://github.com/lxndrbukin",
    icon: "fab fa-github",
  },
  {
    title: "LinkedIn",
    href: "https://www.linkedin.com/in/lxndrbukin/",
    icon: "fab fa-linkedin",
  },
  {
    title: "Instagram",
    href: "https://www.instagram.com/lxndrbukin/",
    icon: "fab fa-instagram",
  },
];
